<div
  [id]="content.id"
  *ngIf="content.title && display"
  class="skymiles-landing-page-micro-moments"
>
  <aura-micro-moments
    [content]="content"
    (dismiss)="display = false"
    (redirect)="redirect($event)"
  ></aura-micro-moments>
</div>
